import React, { FC } from 'react';
import DHDialog from '../dh-dialog/dh-dialog.component';
import { Alert } from '@mui/material';

type HelpDialogProps = {
    open: boolean;
    onDialogClose: () => void;
    title: string;
    helpText: string;
};
const HelpDialog: FC<HelpDialogProps> = ({ open, onDialogClose, title, helpText }: HelpDialogProps) => {
    return (
        <DHDialog title={title} maxWidth="sm" fullWidth open={open} onClose={onDialogClose}>
            <Alert severity="info" sx={{ whiteSpace: 'pre-wrap', marginBottom: 4 }}>
                {helpText}
            </Alert>
        </DHDialog>
    );
};

export default HelpDialog;
